module.exports = __webpack_public_path__ + "img/revisao-final-enem.ba8da68d.png";